module.exports = __webpack_public_path__ + "images/236c9b1b.jpg";